import { useCallback, useState } from 'react'

import {
  DEFAULT_ENTRY_SUBMISSION_LOCALES,
  SubmissionLocale
} from '../components/localeSwitchHeader/LocaleSwitchHeader.types'

import type { CandidateFormSubmission } from '@percent/partner-dashboard/services/grants/grantsService.types'

type FormAnswer = CandidateFormSubmission['formAnswers'][number]

const LANGUAGE_DETECTABLE_PROSE_ANSWER_TYPES: FormAnswer['type'][] = ['text', 'textarea']

export const useAnswerTranslation = (formAnswers: FormAnswer[]) => {
  const [selectedLocale, setSelectedLocale] = useState<string>(SubmissionLocale.EN_US)

  const originalLocale = formAnswers.find(
    a => LANGUAGE_DETECTABLE_PROSE_ANSWER_TYPES.includes(a.type) && a.translatedAnswer != null
  )?.translatedAnswer?.detectedSourceLanguage
  const isEnglish =
    !!originalLocale && (DEFAULT_ENTRY_SUBMISSION_LOCALES.includes(originalLocale) || originalLocale.startsWith('en'))
  const isTranslated = !!originalLocale && !isEnglish
  const translationAvailable = formAnswers.some(
    a => a.translatedAnswer?.localizedAnswers && Object.keys(a.translatedAnswer.localizedAnswers).length > 0
  )

  const getAnswerContent = useCallback(
    (answer: FormAnswer) => answer.translatedAnswer?.localizedAnswers?.[selectedLocale] ?? answer.answer,
    [selectedLocale]
  )

  const getQuestionLabel = useCallback(
    (answer: FormAnswer) =>
      answer.dashboardLabel ?? answer.translatedQuestionLabel?.[selectedLocale] ?? answer.questionLabel,
    [selectedLocale]
  )

  return {
    selectedLocale,
    setSelectedLocale,
    originalLocale: originalLocale ?? '',
    isTranslated,
    translationAvailable,
    getAnswerContent,
    getQuestionLabel
  }
}
